<template>
  <div id="contenedor-eliminar-expediente">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Documento Expediente </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el documento
          "{{expedienteEliminar.descripcion}}" del catalogo de expediente?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarCatalogoExpediente"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoExpedientes from './mixCatalogoExpedientes';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarExpediente',
  mixins: [mixCatalogoExpedientes],
  props: {
    expedienteEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
